import flatpickr from 'flatpickr';
import { Russian as RussianLocale } from 'flatpickr/dist/l10n/ru.js';
import 'flatpickr/dist/flatpickr.min.css';

const DATE_FORMAT = 'Y-m-d H:i:S';

function parseDateString(value) {
	if (!value) return null;
	const normalized = value.replace(' ', 'T');
	const parsed = new Date(normalized);
	return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function formatDate(date) {
	const pad = (value) => String(value).padStart(2, '0');
	return [
		date.getFullYear(),
		'-',
		pad(date.getMonth() + 1),
		'-',
		pad(date.getDate()),
		' ',
		pad(date.getHours()),
		':',
		pad(date.getMinutes()),
		':',
		pad(date.getSeconds())
	].join('');
}

function updateLocation(params) {
	const url = new URL(window.location.href);
	Object.entries(params).forEach(([key, value]) => {
		if (value === null || value === undefined || value === '') {
			url.searchParams.delete(key);
		} else {
			url.searchParams.set(key, value);
		}
	});
	window.location.href = url.toString();
}

function initDateTimeRange(controlElement) {
	const input = controlElement.querySelector('.js-visual-filter-input');
	if (!input) return;

	const paramFrom = controlElement.dataset.paramFrom;
	const paramTo = controlElement.dataset.paramTo;
	if (!paramFrom || !paramTo) return;

	const initialFrom = parseDateString(controlElement.dataset.initialFrom);
	const initialTo = parseDateString(controlElement.dataset.initialTo);

	const flatpickrOptions = {
		enableTime: true,
		time_24hr: true,
		dateFormat: DATE_FORMAT,
		locale: RussianLocale,
		mode: 'range'
	};
	if (initialFrom && initialTo) {
		flatpickrOptions.defaultDate = [initialFrom, initialTo];
	}

	const picker = flatpickr(input, flatpickrOptions);

	const applyButton = controlElement.querySelector('.js-visual-filter-apply');
	if (applyButton) {
		applyButton.addEventListener('click', () => {
			const selectedDates = picker ? picker.selectedDates : [];
			if (!selectedDates.length) {
				updateLocation({ [paramFrom]: null, [paramTo]: null });
				return;
			}

			const fromDate = selectedDates[0] || null;
			const toDate = selectedDates[1] || selectedDates[0] || null;
			const payload = {};
			payload[paramFrom] = fromDate ? formatDate(fromDate) : null;
			payload[paramTo] = toDate ? formatDate(toDate) : null;
			updateLocation(payload);
		});
	}

	const clearButton = controlElement.querySelector('.js-visual-filter-clear');
	if (clearButton) {
		clearButton.addEventListener('click', () => {
			if (picker) picker.clear();
			updateLocation({ [paramFrom]: null, [paramTo]: null });
		});
	}
}

export function initVisualControls() {
	document.querySelectorAll('[data-control-type="datetimerange"]').forEach((element) => {
		initDateTimeRange(element);
	});
}
